import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@polichat/flamboyant';
import { useSelector } from 'react-redux';
import poliConfig from 'src/utils/poliConfig';

import { connect } from 'react-redux';
import { useFlags } from 'flagsmith/react';
import { DivStatusExport } from '../../../../../pages/report/shared/components/Table/styles';

function SidebarItem({ props, userConfig }) {
  const current_customer_id = useSelector(
    (state) => state.general.current_customer_id
  );
  const wlConfig = useSelector((state) => state?.whitelabel?.config);
  const flag = useFlags(['can_view_crm']);

  const handleClick = () => {
    if (props.url == '/home') {
      const url =
        wlConfig?.home_redirect_to ??
        `${poliConfig.poliAppLaravelUrl}${props.url}`;
      window.location.assign(url);
    } else if (
      props.url == '/shopping' ||
      props.url == '/tools' ||
      props.url == '/ads' ||
      props.url == '/chat' ||
      props.url == '/relatorio' ||
      props.url == '/automation'
    ) {
      window.location.assign(props.url);
    } else {
      const url = `${poliConfig.poliAppLaravelUrl}${props.url}/${current_customer_id}`;
      window.location.assign(url);
    }
  };

  const userSuperRole = userConfig?.superRole;
  const active = props.active;
  let style = styles.container;
  let iconStyle = styles.icon;
  let className = 'sidebarMenuItem';

  const renderedIcon =
    typeof props.icon === 'string' ? (
      <Icon icon={props.icon} style={iconStyle} />
    ) : (
      <div
        style={{
          color: 'var(--activated-icons-color)',
        }}
      >
        {props.icon}
      </div>
    );

  if (active) {
    className = 'sidebarMenuItem active';
    style = {
      ...style,
      color: 'var(--activated-icons-color)',
      backgroundColor: 'var(--icon-sidebar-background)',
      borderLeft: '0.25em solid var(--green-polichat)',
    };

    iconStyle = { ...iconStyle, transform: 'matrix(-1, 0, 0, 1, 0, 0)' };
  }

  if (
    userConfig &&
    (userSuperRole === 'adm' ||
      userSuperRole === 'manager' ||
      (props.url === '/crm/index' &&
        userSuperRole === 'agent' &&
        flag.can_view_crm?.value?.includes(`${current_customer_id}`)))
  ) {
    return (
      <div style={{ textDecoration: 'none' }} onClick={handleClick}>
        <div style={style} className={className}>
          {renderedIcon}
          <span>{props.title}</span>
        </div>
      </div>
    );
  } else {
    if (props.url === '/' || props.url === '/chat') {
      return (
        <Link to={props.url} style={{ textDecoration: 'none' }}>
          <div style={style} className={className}>
            {renderedIcon}
            <span>{props.title}</span>
          </div>
        </Link>
      );
    } else {
      return <></>;
    }
  }
}

const styles = {};

const mapStateToProps = (state, ownProps) => ({
  userConfig: state?.general?.user,
  props: ownProps,
});

export default connect(mapStateToProps)(SidebarItem);
